<ng-container #qualifiedProductsContainer></ng-container>

<product-generic-grid-al-v1 *ngIf="showGrid && objGridData.apiType !== 's-bogo' && !isBXGYEligibleOffer"
    data-infinite-scroll-type="client"
    data-load-type="loadmore"
    data-load-more-mobile-items="10"
    data-load-more-tablet-items="10"
    data-load-more-desktop-items="10"
    [objGridData]="objGridData"
    [dataValue]="dataValue"
    [calledBy]="triggerBy"
    [qualifiedProducts]="JSONqualifiedProductsResponse"
    [configObj]="configObj"
    [offersFromDynamicGrid]="offers">
</product-generic-grid-al-v1>

<product-generic-grid-al-v1 *ngIf="showGrid && objGridData.apiType === 's-bogo' && !isBXGYEligibleOffer"
    data-infinite-scroll-type="client"
    data-load-type="loadmore"
    data-load-more-mobile-items="10"
    data-load-more-tablet-items="10"
    data-load-more-desktop-items="10"
    [objGridData]="objGridData"
    [dataValue]="dataValue"
    [calledBy]="triggerBy"
    [qualifiedProducts]="JSONqualifiedProductsResponse"
    [configObj]="configObj"
    [offersFromDynamicGrid]="offers">
</product-generic-grid-al-v1>

<ng-container *ngIf="isBXGYEligibleOffer">
    <div class="product-wrapper-v2 product-wrapper-v2--details section mt-0">
        <div class="product-tabs mt-0 w-100" role="region" aria-label="Section for Eligible to buy, Eligible to get">
            <ul *ngIf="upcList.length && eligibleUpcList.length" class="nav product-tabs__nav" role="tablist" aria-orientation="horizontal">
                <li class="product-tabs__nav__item text-center w-50 p-0 pt-3 pb-3" role="presentation">
                    <a href="#eligibleToBuy" data-toggle="tab" role="tab" aria-controls="eligibleToBuy" (click)="handleTab(false, $event)" class="title-xs active" attr.aria-label="Eligible to buy ({{upcList.length}}) product">
                        Eligible to buy ({{upcList.length}})
                    </a>
                </li>
                <li class="product-tabs__nav__item text-center w-50 p-0 pt-3 pb-3" role="presentation">
                    <a href="#eligibleToGet" data-toggle="tab" role="tab" aria-controls="eligibleToGet" (click)="handleTab(true, $event)" class="title-xs" attr.aria-label="Eligible to get ({{eligibleUpcList.length}}) product">
                        Eligible to get ({{eligibleUpcList.length}})
                    </a>
                </li>
            </ul>

            <div class="product-tabs__bar"></div>
            <div class="tab-content product-tabs__content">
                <div class="tab-pane fade show active body-text" id="eligibleToBuy" tabindex="0">
                    <product-generic-grid-al-v1 *ngIf="showGrid"
                                                data-infinite-scroll-type="client"
                                                data-load-type="loadmore"
                                                data-load-more-mobile-items="10"
                                                data-load-more-tablet-items="10"
                                                data-load-more-desktop-items="10"
                                                [objGridData]="objGridData"
                                                [dataValue]="dataValue"
                                                [calledBy]="triggerBy"
                                                [qualifiedProducts]="JSONqualifiedProductsResponse"
                                                [configObj]="configObj">
                    </product-generic-grid-al-v1>
                </div>
                <div class="tab-pane fade body-text" id="eligibleToGet" tabindex="0">
                    <product-generic-grid-al-v1 *ngIf="showGrid && eligibleJSONqualifiedProductsResponse.length"
                                                data-infinite-scroll-type="client"
                                                data-load-type="loadmore"
                                                data-load-more-mobile-items="10"
                                                data-load-more-tablet-items="10"
                                                data-load-more-desktop-items="10"
                                                [objGridData]="objGridData"
                                                [dataValue]="dataValue"
                                                [calledBy]="triggerBy"
                                                [qualifiedProducts]="eligibleJSONqualifiedProductsResponse"
                                                [configObj]="configObj">
                    </product-generic-grid-al-v1>
                </div>
            </div>
        </div>
    </div>
</ng-container>
